{
  "name": "@signalwire/compatibility-api",
  "description": "SignalWire Compatibility API",
  "author": "SignalWire Team <open.source@signalwire.com>",
  "license": "MIT",
  "version": "3.1.4",
  "keywords": [
    "signalwire",
    "voice",
    "laml",
    "sms",
    "rest",
    "api"
  ],
  "repository": {
    "type": "git",
    "url": "https://github.com/signalwire/compatibility-api-js"
  },
  "bugs": {
    "url": "https://github.com/signalwire/compatibility-api-js/issues"
  },
  "homepage": "https://developer.signalwire.com/compatibility-api",
  "dependencies": {
    "axios": "^0.26.1",
    "dayjs": "^1.8.29",
    "https-proxy-agent": "^5.0.0",
    "jsonwebtoken": "9.0.0",
    "lodash": "^4.17.21",
    "q": "2.0.x",
    "qs": "^6.9.4",
    "rootpath": "^0.1.2",
    "scmp": "^2.1.0",
    "url-parse": "^1.5.9",
    "xmlbuilder": "^13.0.2"
  },
  "devDependencies": {
    "@types/node": "9.6.57",
    "esbuild": "^0.17.19",
    "esbuild-node-externals": "^1.7.0",
    "eslint": "^7.28.0",
    "express": "^4.17.1",
    "jasmine": "~3.5.0",
    "jsdoc": "^4.0.2",
    "jshint": "^2.11.0",
    "mock-fs": "^4.12.0",
    "nock": "^10.0.6",
    "node-mocks-http": "^1.8.1",
    "nyc": "^15.1.0",
    "proxyquire": "^2.1.3",
    "typescript": "^2.9.2"
  },
  "scripts": {
    "test": "npm run test:javascript && npm run test:typescript",
    "test:javascript": "jasmine spec/**/**.spec.js",
    "test:typescript": "tsc examples/typescript/example.ts --noEmit --strict",
    "jshint": "jshint lib/rest/** lib/base/** lib/http/**",
    "jscs": "eslint lib/base/**/**.js lib/http/**/**.js --fix",
    "check": "npm run jshint && npm run jscs",
    "ci": "npm run nyc && npm run nsp",
    "coverage": "nyc npm test",
    "jsdoc": "jsdoc -r lib -d docs",
    "nsp": "if [ `npm --version | cut -d'.' -f1` -ge \"6\" ]; then npm audit --production; else echo \"npm audit is not available for npm < 6.0\"; fi",
    "nyc": "if [ `node --version | cut -d'.' -f1 | cut -c2-` -ge \"8\" ]; then npm run coverage; else npm test; fi",
    "tsc": "tsc -p tsconfig.cjs.json",
    "tsc:esm": "tsc -p tsconfig.esm.json",
    "build": "node build.js"
  },
  "files": [
    "dist",
    "lib",
    "src",
    "index.js",
    "index.d.ts",
    "compatibility-api.d.ts"
  ],
  "main": "dist/index.node.js",
  "exports": {
    "require": "./dist/index.node.js",
    "default": "./dist/index.node.mjs"
  },
  "types": "./compatibility-api.d.ts",
  "engines": {
    "node": ">=12"
  }
}
